import { InvoiceTextPlusOutlineIcon } from './InvoiceTextPlusOutlineIcon';

/**
 * author: Jeff Anders
 * id 2A2F9351-D61A-47D7-B215-5E68E343759A
 * name invoice-text-plus-outline
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invoice-text-plus-outline.svg
 * tags
 * - Banking 
 * - Shopping 
 */
export const InvoiceTextNewOutlineIcon = InvoiceTextPlusOutlineIcon;
export default InvoiceTextNewOutlineIcon